import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { colors } from "../../../utils/colors";
import { a11yProps } from "./CustomTabPanel";

interface TabHeaderProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  isAdmin: boolean;
  yardName: string;
}

export function TabHeader({
  value,
  onChange,
  isAdmin,
  yardName,
}: TabHeaderProps): React.JSX.Element {
  if (isAdmin) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: "SigmaSans",
            fontWeight: "bold",
            color: colors.primaryText,
          }}
        >
          {yardName}
        </Typography>
        <Tabs value={value} onChange={onChange} aria-label="basic tabs example">
          <Tab label="Yard" {...a11yProps(0)} />
          <Tab label="Dev" {...a11yProps(1)} />
        </Tabs>
      </Box>
    );
  }

  return (
    <Typography
      variant="h4"
      sx={{
        fontFamily: "SigmaSans",
        fontWeight: "bold",
        color: colors.primaryText,
      }}
    >
      {yardName}
    </Typography>
  );
}
